import gql from "graphql-tag";
import { COMPANY_SEARCH_FRAGMENT, CORPORATE_FRAGMENT } from "./fragment";

export const CREATE_CORPORATE = gql`
  mutation CreateCorporate($input: CreateCorporateInput!) {
    createCorporate(input: $input) {
      ...CorporateInfo
    }
  }
  ${CORPORATE_FRAGMENT}
`;

export const SEARCH_COMPANY = gql`
  mutation SearchCompany($search: String!, $targets: [String], $length: Int) {
    searchCompany(search: $search, targets: $targets, length: $length) {
      ...SearchCompanyResultInfo
    }
  }
  ${COMPANY_SEARCH_FRAGMENT}
`;
